import { ref } from 'vue'
import type { AccountBillItem } from '@/api/billApi'

type EmitType = {
  (event: 'selection-change', keys: string[]): void
}

export const useRowSelection = (emit: EmitType) => {
  const selectedRowKeys = ref<string[]>([])
  const selectedRows = ref<AccountBillItem[]>([])

  const onSelectChange = (keys: string[], rows: AccountBillItem[]) => {
    selectedRowKeys.value = keys
    selectedRows.value = rows
    emit('selection-change', keys)
  }

  return { selectedRowKeys, selectedRows, onSelectChange }
}
